import { defineComponent as _defineComponent } from 'vue'
import { getDomainAndPlatform } from '@/modules/common/helpers/onboarding/getDomainAndPlatform';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { BaseText, ButtonPrimary, Heading } from '@warrenbrasil/nebraska-web';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'HomeSuitability',
  setup(__props) {

const buttonHref = computed(() => {
  const { domain, platform } = getDomainAndPlatform();

  return `/onboarding/${domain}/${platform}/suitability`;
});

return { __sfc: true,buttonHref, NebraskaColors, BaseText, ButtonPrimary, Heading }
}

})